var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { CommonThemeColors } from "./theme";
var LabeledValue = function (props) {
    return (_jsxs(Stack, __assign({ gap: 0.5, sx: __assign({ alignItems: 'flex-start' }, props.sx) }, { children: [props.children, _jsx(Typography, __assign({ variant: 'body2', color: CommonThemeColors.sys.text.secondary }, { children: props.label }))] })));
};
export default LabeledValue;
